/**
 * Suffisso prezzo in base all'unità di noleggio della barca (rental_mode).
 * Es. "A partire da 1.120€ · a settimana". Default "al giorno".
 */
export function priceUnitLabel(rentalMode?: string | null): string {
  switch (rentalMode) {
    case 'weekly':
      return 'a settimana';
    case 'monthly':
      return 'al mese';
    case 'hourly':
      return "all'ora";
    default:
      return 'al giorno';
  }
}
